import React, { useState, useRef } from 'react';
import InsertSymbolForm from './InsertSymbolForm';

const SymbolSideMenuWebComponent = (props) => {
  return (
    <>
        <InsertSymbolForm props={props}/>
    </>
  )
};

export default React.memo(SymbolSideMenuWebComponent);
